import { render } from "./LoadScreenModal.vue?vue&type=template&id=5b96dcf2&scoped=true"
import script from "./LoadScreenModal.vue?vue&type=script&lang=js"
export * from "./LoadScreenModal.vue?vue&type=script&lang=js"

import "./LoadScreenModal.vue?vue&type=style&index=0&id=5b96dcf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b96dcf2"]])

export default __exports__